import React, { FC } from 'react';

import { Card, HeadingText, Spacer, Text } from '@components/1-atoms';
import { Button, Info, Input, } from '@components/2-molecules';
import { AuthTemplate } from '@components/4-templates';

import PayBooks from '@assets/paybooks';

import { withForwardedNavigationParams } from 'react-navigation-props-mapper';

import Mail from '@assets/icons/mail';
import { STATE, TermsOfUseUrl } from '@lib/constants';
import { useEmail } from '@lib/hooks/base/useAuth';
import { useGoogleSignIn } from '@lib/hooks/useGoogleAuth';
import * as utils from '@lib/utils';
import * as WebBrowser from 'expo-web-browser';

import GoogleButton from '@/components/2-molecules/GoogleButton';
import { ForwardedPageProps } from '@lib/constants';
import setTheme from '@lib/theme';


const theme = setTheme('light');

const EmailLogin: FC<ForwardedPageProps> = ({ navigation, data = {}, ...props }) => {

  const [email, setEmail] = useEmail({ operation: 'POST', data: data, state: STATE.CANCEL, message: 'Verifying ...' });

  // Verify email with an OTP
  const verifyEmail = (): void => { setEmail({ ...email, state: STATE.READY, message: 'Verifying...' }) };

  // Verify and login with Google OAuth2; the hook returns a callback
  const googleSignInCallback = useGoogleSignIn();
  // This is a callback not a hook; the above is in web environment
  const verifyEmailWithGoogle = () => googleSignInCallback();

  const updateEmail = (data: any): void => setEmail((email: any) => ({ ...email, data: { ...email.data, ...data } }));
  utils.onStateChange(email, STATE.DONE, (data: any) => navigation.navigate('OtpLogin', { data: data }));

  const goToTermsOfUse = () => WebBrowser.openBrowserAsync(TermsOfUseUrl);

  return (
    <AuthTemplate noPadding={true} hooks={[email]}>

      <Spacer h={1} /><PayBooks /><Spacer h={4} />

      <HeadingText color='white'>Advanced financial insights and document management</HeadingText>

      <Spacer h={3} />

      <Card>
        <Spacer h={1} />
        <Text large bold color={theme.pallete.textColor}>LOGIN</Text>
        <Spacer h={2} />


        <GoogleButton inset onPress={verifyEmailWithGoogle}>CONTINUE WITH GOOGLE</GoogleButton>

        <Spacer h={1} />
        <Text xsmall bold>OR</Text>
        <Spacer h={1} />

        <Input left={<Mail />}
          inputMode={"email"}
          placeholder={"Email address"}
          autoComplete={"email"}
          autoCapitalize={"none"}
          defaultValue={email?.data?.email}
          onChange={value => { updateEmail({ email: value }) }}
          onSubmitEditing={verifyEmail} />
        <Spacer h={2} />

        <Button inset onPress={verifyEmail}>CONFIRIM WITH AN OTP</Button>
        <Spacer h={1} />

        <Info>You will need to verify your email with a One Time Password (OTP) that will be sent to you shortly after.</Info>
        <Spacer h={2} />

        <Button color={theme.pallete.accentColor} bg={"transparent"} onPress={goToTermsOfUse}>TERMS OF USE</Button>
      </Card>
      <Spacer h={1} />

    </AuthTemplate>
  );
};

export default withForwardedNavigationParams<ForwardedPageProps>()(EmailLogin);
